export default {
  LAYERS_PANEL: '4da3c6cd-dbb3-42c9-9fdd-eba0da517833',
};
